/*
 * 送料無料キャンペーン｜カート追加ポップアップの送料表示を差し替える。
 *
 * ポップアップの文言は theme.js と add-cart.js が innerHTML で書き込む。
 * その2箇所から呼べるように、判定と文言をここに1つだけ置く。
 *
 * 期間と文言は snippets/c-free-shipping-campaign.liquid が唯一の置き場で、
 * data-free-shipping-campaign-config のJSONとして渡ってくる（ここには書かない）。
 * 期間外・設定なし・JSON壊れのいずれでも null を返すので、
 * 呼び出し側は今までどおりの「あと◯円で送料無料」を出す。
 */
window.freeShippingCampaignHtml = function () {
  try {
    var el = document.querySelector('[data-free-shipping-campaign-config]');
    if (!el) return null;

    var cfg = JSON.parse(el.textContent);
    var now = Math.floor(Date.now() / 1000);
    if (now < cfg.starts || now > cfg.ends) return null;

    return cfg.html || null;
  } catch (e) {
    return null;
  }
};
